import { render, staticRenderFns } from "./CsimSchemaAttributeSelectedFormList.vue?vue&type=template&id=0c070356&scoped=true"
import script from "./CsimSchemaAttributeSelectedFormList.vue?vue&type=script&lang=js"
export * from "./CsimSchemaAttributeSelectedFormList.vue?vue&type=script&lang=js"
import style0 from "./CsimSchemaAttributeSelectedFormList.vue?vue&type=style&index=0&id=0c070356&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c070356",
  null
  
)

export default component.exports